import { useTranslation } from 'react-i18next';

import { Select } from '@actual-app/components/select';
import { SpaceBetween } from '@actual-app/components/space-between';
import type {
  AverageTemplate,
  CopyTemplate,
} from '@actual-app/core/types/models/templates';

import { updateTemplate } from '#components/budget/goals/actions';
import type { Action } from '#components/budget/goals/actions';
import { AmountAdjustment } from '#components/budget/goals/editor/AmountAdjustment';
import { FormField, FormLabel } from '#components/forms';
import { GenericInput } from '#components/util/GenericInput';

type HistoricalAutomationProps = {
  template: CopyTemplate | AverageTemplate;
  dispatch: (action: Action) => void;
};

export const HistoricalAutomation = ({
  template,
  dispatch,
}: HistoricalAutomationProps) => {
  const { t } = useTranslation();

  return (
    <>
      <SpaceBetween gap={50} style={{ marginTop: 10 }}>
        <FormField style={{ flex: 1 }}>
          <FormLabel title={t('Mode')} htmlFor="mode-field" />
          <Select
            id="mode-field"
            key="mode-picker"
            options={[
              ['copy', t('Copy a previous month')],
              ['average', t('Average of previous months')],
            ]}
            value={template.type}
            onChange={type => dispatch(updateTemplate({ type }))}
          />
        </FormField>
        <FormField style={{ flex: 1 }}>
          <FormLabel
            title={t('Number of months back')}
            htmlFor="look-back-field"
          />
          <GenericInput
            key="look-back-input"
            type="number"
            value={
              template.type === 'average'
                ? template.numMonths
                : template.lookBack
            }
            onChange={value =>
              dispatch(
                updateTemplate(
                  template.type === 'average'
                    ? { type: 'average', numMonths: value }
                    : { type: 'copy', lookBack: value },
                ),
              )
            }
          />
        </FormField>
      </SpaceBetween>
      {template.type === 'average' && (
        <AmountAdjustment template={template} dispatch={dispatch} />
      )}
    </>
  );
};
